import { ContactRow } from "../../api/relationship.type";
import Avatar from "../shared/avatar";
import Typography from "../shared/typography";

interface MutualContactItemProps {
  contact: ContactRow;
}

const MutualContactItem = ({ contact }: MutualContactItemProps) => {
  const fullName = `${contact?.related_user?.first_name || ""} ${
    contact?.related_user?.last_name || ""
  }`.trim();

  const hasAvatar = !!contact?.related_user?.avatar_url;

  return (
    <li
      key={contact?.id}
      className={
        hasAvatar
          ? "list-none"
          : "text-terracotta-500 marker:text-terracotta-600"
      }
    >
      <div className="flex items-center gap-3">
        <Avatar
          src={contact?.related_user?.avatar_url}
          alt={`${fullName} avatar`}
          size="sm"
          fallbackText={fullName}
        />
        <div className="flex-1">
          <Typography variant="body1" className="text-primary">
            {fullName}
          </Typography>
          {contact?.relationship_type && (
            <Typography variant="caption" className="text-primary block mt-1">
              {contact.related_user_role}
            </Typography>
          )}
        </div>
      </div>
    </li>
  );
};

export default MutualContactItem;
